import React, { Component } from 'react';
import _ from 'lodash';
import { Button, Col, Input, Modal, Row } from 'antd';
import AddImage from './AddImage';
import { connect } from 'react-redux';
import actions from '../../redux/actions/setting_data/index';
import utils from '../../common/utils';
import DisplayControl from '../DisplayControl';
import Loadingsvg from '../common/Loadingsvg';
import consts, { TIME_OF_DEBOUNCE } from '../../consts';

const { TextArea } = Input;
const PERMISSION_LINK_SCREEN_UPDATE_COIN = '/setting/update-coin';

class PopupEditCoins extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleConfirm: false,
      deleteInform: false,
      coinSetting: {
        coin: '',
        contract_address: '',
        icon_image: '',
        name: '',
        symbol: '',
        decimal: '',
        transaction_explorer: '',
        fee: 0,
        minimum_withdrawal: 0,
        confirmation: 0,
      },
      
      isLoadingSubmit: false
    };
  }
  
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (utils.hash(nextProps.coinSetting) !== utils.hash(this.props.coinSetting)) {
      this.setState({ coinSetting: nextProps.coinSetting });
    }
  }
  
  componentDidMount() {
    this.setState({ coinSetting: this.props.coinSetting });
  }
  
  handleOk = (e) => {
    // console.log("data",this.state.coinSetting.coin+" "+ this.state.coinSetting.fee +" "+this.state.coinSetting.minimum_withdrawal)
    this.setState({
      visibleConfirm: true,
    });
  };
  
  handleCancel = (e) => {
    this.props.closePopup(false);
    this.setState({
      coinSetting: this.props.coinSetting
    });
  };
  
  handleOkConfirm = (e) => {
    this.setState({
      isLoadingSubmit: true
    });
    this.handleOkConfirmSubmit();
  };
  
  handleOkConfirmSubmit = _.debounce(() => {
    console.log('this.state.setting', this.state.coinSetting);
    this.props.postCoinSetting({
      ...this.state.coinSetting,
      fee: parseFloat(this.state.coinSetting.fee),
      minimum_withdrawal: parseFloat(this.state.coinSetting.minimum_withdrawal),
      confirmation: parseFloat(this.state.coinSetting.confirmation),
    }, () => {
      this.props.closePopup(true);
      this.setState({
        visibleConfirm: false,
        isLoadingSubmit: false
      });
    });
    this.props.postLimitSetting({
      currency: this.state.coinSetting.coin,
      fee: parseFloat(this.state.coinSetting.fee),
      minimum_withdrawal: parseFloat(this.state.coinSetting.minimum_withdrawal),
      confirmation: parseFloat(this.state.coinSetting.confirmation),
      limit: 1000,
      security_level: 1,
    }, () => {
      this.props.closePopup(true);
      this.setState({
        visibleConfirm: false,
        isLoadingSubmit: false
      });
    });
    
    //get data of coin table by dispatch action INIT
    this.props.__INIT__();
  }, TIME_OF_DEBOUNCE);
  
  handleCancelConfirm = (e) => {
    this.setState({
      visibleConfirm: false,
    });
  };
  
  handleImage = (imageUrl) => {
    let coinSetting = this.state.coinSetting;
    coinSetting.icon_image = imageUrl;
    this.setState({
      coinSetting: coinSetting,
    });
  };
  
  onChangeCoin = ({ target: { value: coin } }) => {
    this.setState({
      coinSetting: {
        ...this.state.coinSetting,
        coin,
        symbol: coin
      }
    });
  };
  
  onChangeName = ({ target: { value: name } }) => {
    this.setState({
      coinSetting: {
        ...this.state.coinSetting,
        name
      }
    });
  };
  
  onChangeFee = ({ target: { value: fee } }) => {
    this.setState({
      coinSetting: {
        ...this.state.coinSetting,
        fee
      }
    });
  };
  onChangeMinimum = ({ target: { value: minimum_withdrawal } }) => {
    this.setState({
      coinSetting: {
        ...this.state.coinSetting,
        minimum_withdrawal
      }
    });
  };
  
  onConfirmation = ({ target: { value: confirmation } }) => {
    this.setState({
      coinSetting: {
        ...this.state.coinSetting,
        confirmation
      }
    });
  };
  
  onChangeContractAddr = ({ target: { value: contract_address } }) => {
    this.setState({
      coinSetting: {
        ...this.state.coinSetting,
        contract_address
      }
    });
  };
  
  onChangePathCoin = ({ target: { value: transaction_explorer } }) => this.setState({
    coinSetting: {
      ...this.state.coinSetting,
      transaction_explorer,
    }
  });
  
  render() {
    const { coinSetting } = this.state;
    
    return (
      <div>
        <Modal
          width="700px"
          className={'popup-add-coin'}
          title={<h3 style={{ marginBottom: 0 }}>Sửa đồng mới</h3>}
          visible={this.props.isVisible}
          footer={[
            <Button style={{ marginTop: '10px' }} type="primary" onClick={this.handleCancel}>
              Hủy
            </Button>,
            <Button type="primary" onClick={this.handleOk}>
              Lưu
            </Button>
          ]}
          onCancel={this.handleCancel}
        >
          <Row>
            <Col span={10}>
              <div>Đồng</div>
              <Input
                placeholder="Đồng"
                onChange={this.onChangeCoin}
                value={coinSetting?.coin}
                disabled={true}
              />
            </Col>
            <Col span={10} offset={4}>
              <div>Tên đầy đủ</div>
              
              <Input
                placeholder="Tên đầy đủ"
                disabled={true}
                onChange={this.onChangeName}
                value={coinSetting?.name}
              />
            </Col>
          </Row>
          <br/>
          <Row>
            <Col span={10}>
              <div>Mạng</div>
              
              <Input
                placeholder="Mạng"
                value={coinSetting?.type}
              />
            </Col>
            <Col span={10} offset={4}>
              <div>Đơn vị</div>
              <Input
                placeholder="Đơn vị"
                disabled={true}
                value={coinSetting?.coin}
              />
            </Col>
          </Row>
          <br/>
          <Row>
            <Col span={10}>
              <div>Phí rút</div>
              <Input
                
                name="fee"
                onChange={this.onChangeFee}
                placeholder="Phí rút"
                value={coinSetting?.fee}
              />
              {/* <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors['params.fee'] || '')}</Text>
              </div> */}
            </Col>
            <Col span={10} offset={4}>
              <div>Số lượng rút nhỏ nhất</div>
              <Input
                
                name="minimum_withdrawal"
                onChange={this.onChangeMinimum}
                placeholder="Số lượng rút nhỏ nhất"
                value={coinSetting?.minimum_withdrawal}
              />
              {/* <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors['params.minimum_withdrawal'] || '')}</Text>
              </div> */}
            </Col>
          </Row>
          <br/>
          <Row>
            <Col span={10}>
              <div>Số lượng xác nhận</div>
              <Input
                
                name="confirmation"
                onChange={this.onConfirmation}
                placeholder="Số lượng xác nhận"
                value={coinSetting?.confirmation}
              />
            </Col>
          </Row>
          
          <br/>
          <Row>
            <Col span={4}>
              <div>Biểu tượng</div>
              <div>
                <AddImage
                  handleImage={this.handleImage}
                  imageUrl={coinSetting?.icon_image}
                />
              </div>
            </Col>
            <Col span={19} offset={1}>
              {/* <div>Ghi chú</div>

              <TextArea rows={6} style={{ maxHeight: '102px' }} /> */}
              <div>Lối mã giao dịch</div>
              <Input
                placeholder="Lối mã giao dịch"
                // value={coinSetting?.transaction_explorer}
                value={coinSetting?.transaction_explorer}
                onChange={this.onChangePathCoin}
              />
            </Col>
          </Row>
          {/* <Row justify="end" align="bottom">
            <Col span={3} offset={16}>
              <Button style={{ marginTop: "10px" }} type="primary" onClick={this.handleCancel}>
                Hủy
            </Button>
            </Col>
            <Col span={2} >
            <DisplayControl permission_link_screen={PERMISSION_LINK_SCREEN_UPDATE_COIN} action="POST">
              <Button type="primary" onClick={this.handleOk}>
                Lưu
            </Button>
            </DisplayControl>
            </Col>
          </Row> */}
        </Modal>
        {/* confirm */}
        <Modal
          style={{ top: 250 }}
          visible={this.state.visibleConfirm}
          footer={[
            <Button style={{ marginTop: '10px' }} type="primary" onClick={this.handleCancelConfirm}>
              Hủy
            </Button>,
            <DisplayControl
              permission_link_screen={[
                {
                  permission: consts.AUTH.SETTING__UPDATE_LIMIT_WITHDRAWAL,
                  action: consts.CONTROLS.POST
                },
                {
                  permission: consts.AUTH.SETTING__UPDATE_COIN,
                  action: consts.CONTROLS.POST
                },
              ]}>
              <Button type="primary" htmlType="submit" style={{ width: '85px' }}
                      icon={<Loadingsvg name='bars'
                                        hidden={!this.state.isLoadingSubmit} size={25}/>}
                      onClick={this.handleOkConfirm}>
                {this.state.isLoadingSubmit === false ? 'Xác nhận' : ''}
              </Button>
            </DisplayControl>
          
          ]}
          onCancel={this.handleCancelConfirm}
        >
          <div>Bạn có chắc muốn lưu thông tin?</div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  __INIT__: () => {
    dispatch({ type: '@@__INIT__' });
  },
  postCoinSetting: (params, callback) => {
    dispatch(actions.updateCoinAction(params, callback));
  },
  postLimitSetting: (params, callback) => {
    dispatch(actions.updateLimitWithdrawalAction(params, callback));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(PopupEditCoins);
